// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/modules/es6.object.assign.js
// module id = 1478
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16